import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from '@/core/config/routeConfig';
import { useMessageTemplateStore } from '@/entities/MessageTemplate/model/store';
import { MESSAGE_TEMPLATE_GROUP_COLUMNS } from '@/entities/MessageTemplate/config/messageTemplate-table.config';
import { DataTable } from '@/shared/ui/DataTable/DataTable';
import { RequestErrorBanner } from '@/shared/ui/RequestState';
import { RequestStatus } from '@/shared/model/requestStatus';

/** Показывает группы текстовок приложения */
export const MessageTemplateGroupsPage = () => {
    const { groups, groupsStatus, groupsError, fetchGroups, reset } = useMessageTemplateStore();
    const navigate = useNavigate();

    useEffect(() => {
        void fetchGroups();

        return reset;
    }, [fetchGroups, reset]);

    return (
        <main>
            <h1>Текстовки приложения</h1>
            <p>Откройте группу, чтобы посмотреть и изменить её сообщения.</p>
            <RequestErrorBanner
                status={groupsStatus}
                error={groupsError}
                fallbackMessage="Не удалось загрузить группы"
                onRetry={fetchGroups}
            />
            <DataTable
                getRowUrl={item => item.id
                    ? `/message-templates/groups/${encodeURIComponent(item.id)}`
                    : undefined}
                data={groups}
                columns={MESSAGE_TEMPLATE_GROUP_COLUMNS}
                loading={groupsStatus === RequestStatus.Loading}
                onRowClick={(item) => {
                    if (item.id) navigate(RoutePath.messageTemplateGroup.replace(':group', item.id));
                }}
            />
        </main>
    );
};
